import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Row,
} from 'reactstrap';

import { DropdownSelectWithLabel, LabeledField, TextAreaWithLabel, } from '../common/standardComponents';
import {OrderStatusHistoryTable} from '.';
import OrderVisitDetails from './orderVisitDetails';

import './orderDetails.css'

interface CareOrderVisitAppointments {
    id: number,
    siteName: string,
    providerFirstName: string,
    providerLastName: string,
    appointmentType: string,
}
interface CareOrderVisits {
    id: number,
    systemDateRangeName: string,
    careOrderVisitAppointments: CareOrderVisitAppointments[],
}

interface Order {
    id: number,
    status: string,
    statusCode: string,
    createdByFirstName: string,
    createdByLastName: string,
    notes: string,
    entryDate: Date,
    dueDate: Date,
    lastModifiedDate: Date,
    lastModifiedByFirstName: string,
    lastModifiedByLastName: string,
    statusReason: string,
    careOrderVisits: CareOrderVisits[],
    lastUpdatedByFirstName: string,
    lastUpdatedByLastName: string,
    orderDate: Date,
    expirationDate: Date | null,
    updatedAt: Date
}

function OrderDetails(props: any) {

    const {
        cancelLabel,
        confirmLabel,
        isEditMode,
        isOpen,
        onCancel,
        onStatusListChange,
        onStatusNotesChange,
        onStatusReasonListChange,
        onConfirm,
        onEdit,
        order,
        orderStatusDisplay,
        selectedOrderStatusNotes,
        selectedStatusCode,
        selectedStatusReasonId,
        statusOptionsList,
        statusReasonOptionsList,
        title,
        careOrderHistory,
        isParentCreateOrder
    }: {
        cancelLabel: string,
        confirmLabel: string,
        isEditMode: boolean,
        isOpen: boolean,
        onCancel: Function,
        onStatusListChange: Function,
        onStatusNotesChange: Function,
        onStatusReasonListChange: Function,
        onConfirm: Function,
        onEdit: Function,
        order: Order,
        orderStatusDisplay: string,
        selectedOrderStatusNotes: string,
        selectedStatusCode: string,
        selectedStatusReasonId: number,
        statusOptionsList: any[],
        statusReasonOptionsList: any[],
        title: string,
        careOrderHistory: any,
        isParentCreateOrder: boolean
} = props;

    const [activeTab, setActiveTab] = useState<string>("1");
    const [showStatusReasonList, setShowStatusReasonList] = useState<boolean>(true);

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    let createdByName = `${order.createdByFirstName} ${order.createdByLastName}`;
    let lastModByName = (order && order.lastModifiedByFirstName && order.lastModifiedByLastName) ? `${order.lastModifiedByFirstName} ${order.lastModifiedByLastName}` : `${order.lastUpdatedByFirstName} ${order.lastUpdatedByLastName}`;
    let isDetailsTabActive = activeTab === "1" ? "active" : undefined;
    let isHistoryTabActive = activeTab === "2" ? "active" : undefined;

    let statusList = statusOptionsList && statusOptionsList.map((s, i) => {
        return { id: s.code, name: s.name, key: i };
    });
    let statusReasonList = statusReasonOptionsList && statusReasonOptionsList
    .filter(r => r.code === selectedStatusCode)
    .map((r, i) => {
        return { id: r.id, name: r.name, key: i };
    });

    return (
        <div>
            <Col className="details-container">
                <Row>
                    <Col lg="4">
                        { isEditMode ?
                            <Row>
                                <Col lg="6">
                                    <DropdownSelectWithLabel optionList={statusList} id="statusId" label="Order Status" value={selectedStatusCode} isRequired shouldValidate={false} onChange={onStatusListChange} />
                                </Col>
                                <Col lg="6">
                                    <DropdownSelectWithLabel optionList={statusReasonList} id="statusReasonId" label="Reason" value={selectedStatusReasonId} isRequired shouldValidate={false} onChange={onStatusReasonListChange} />
                                </Col>
                            </Row>
                        :   <Row>
                                <Col lg="6">
                                    <LabeledField label="Order Status" value={orderStatusDisplay} />
                                </Col>
                                <Col lg="6">
                                    <LabeledField label="Reason" value={order.statusReason} />
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col lg="3">
                        <LabeledField label="Created By" value={createdByName} />
                    </Col>
                    <Col lg="3">
                        {isParentCreateOrder ? 
                            <LabeledField label="Order Entry Date" value={moment(order.entryDate).format("MM/DD/YYYY")} />
                            : <LabeledField label="Order Date" value={moment(order.orderDate).format("MM/DD/YYYY")} />
                        }
                    </Col>
                    <Col lg="2">
                        {isParentCreateOrder ?
                            <LabeledField label="Due Date" value={moment(order.dueDate).format("MM/DD/YYYY")} />
                            : <LabeledField label="Expiration Date" value={order.expirationDate != null ? moment(order.expirationDate).format("MM/DD/YYYY") : "-"} />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col lg="4">
                        { isEditMode ?
                            <TextAreaWithLabel onChange={onStatusNotesChange} maxLength={1000} id="statusNotes" label="Notes" value={selectedOrderStatusNotes} isRequired={false} shouldValidate={false} />
                        : <LabeledField label="Notes" value={order.notes} /> }
                    </Col>
                    <Col lg="3">
                        {isParentCreateOrder ?
                            <LabeledField label="Last Modified Date" value={moment(order.lastModifiedDate).format("MM/DD/YYYY")} />
                            : <LabeledField label="Last Updated Date" value={moment(order.updatedAt).format("MM/DD/YYYY")} />
                        }
                    </Col>
                    <Col lg="3">
                        {isParentCreateOrder ?
                            <LabeledField label="Last Modified By" value={lastModByName} />
                            : <LabeledField label="Last Updated By" value={lastModByName} />
                        }
                    </Col>
                </Row>
            </Col>
            <Col className="order-details-tab-container">
                <Nav tabs>
                    <NavItem>
                        <NavLink className={isDetailsTabActive} onClick={() => toggle("1")}>
                            Details
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={isHistoryTabActive} onClick={() => toggle("2")}>
                            History
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        { order.careOrderVisits.length > 0 &&
                            order.careOrderVisits.map((cov) => {
                                return (
                                    <div key={cov.id}><OrderVisitDetails visit={cov}/></div>
                                );
                            })
                        }
                    </TabPane>
                    <TabPane tabId="2">
                        <OrderStatusHistoryTable orderHistory={careOrderHistory} />
                    </TabPane>
                </TabContent>
            </Col>
        </div>
    )
    
}

export default OrderDetails;
